import React from "react";
import {  type ITeamsSquad } from "../types/matchDetails.d";

type Props = {
  defaultTab?: "batting" | "bowling";
  players?: ITeamsSquad [];
};

const TeamModal: React.FC<Props> = ({
  defaultTab = "batting",
  players =[],
}) => {
  const [active, setActive] = React.useState<"batting" | "bowling">(defaultTab);

  return (
    <div className="teams-modal">
      {/* Tabs header */}
      <div
        className="tabs"
        role="tablist"
        aria-label="Select team type"
      >
        <button
          type="button"
          className={`tab ${active === "batting" ? "is-active" : ""}`}
          role="tab"
          aria-selected={active === "batting"}
          aria-controls="panel-batting"
          id="tab-batting"
          onClick={() => setActive("batting")}
        >
          BATTING TEAM
        </button>

        <button
          type="button"
          className={`tab ${active === "bowling" ? "is-active" : ""}`}
          role="tab"
          aria-selected={active === "bowling"}
          aria-controls="panel-bowling"
          id="tab-bowling"
          onClick={() => setActive("bowling")}
        >
          BOWLING TEAM
        </button>

        {/* underline indicator */}
        <span
          className={`tab-indicator ${active}`}
          aria-hidden="true"
        />
      </div>

      {/* Panels */}
      <div className="panels">
        <div
          id="panel-batting"
          role="tabpanel"
          aria-labelledby="tab-batting"
          hidden={active !== "batting"}
          className="panel"
        >
          <ul className="player-list" role="list">
            {players?.map((player, idx) => (
              <li key={player?.playerId} className="player-row">
                <span className="player-index">{idx + 1}.</span>
                <span className="player-name">{player?.playerFirstName}</span>
              </li>
            ))}
            {players?.length === 0 && (
              <div className="empty">No batting players</div>
            )}
          </ul>
        </div>

        <div
          id="panel-bowling"
          role="tabpanel"
          aria-labelledby="tab-bowling"
          hidden={active !== "bowling"}
          className="panel"
        >
          <ul className="player-list" role="list">
            {players?.map((player, idx) => (
              <li key={player?.playerId} className="player-row">
                <span className="player-index">{idx + 1}.</span>
                <span className="player-name">{player?.playerFirstName}</span>
              </li>
            ))}
            {players?.length === 0 && (
              <div className="empty">No bowling players</div>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TeamModal;
